import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  Popup,
  Heading,
  TextInput,
  AutocompleteInput,
  Button,
  Status,
  Preloader,
  I18n,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getRegion = () => {
  const regionMeta = document.querySelector('meta[name="REGION_TITLE"]');
  return regionMeta ? regionMeta.content : 'Москва';
};

export default class NewAddressPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      region: getRegion(),
      street: null,
      house: null,
      flat: null,
      streets: [],
      houses: [],
      isSuccess: false,
      isError: false,
    };
  }

  getStreets = async (value) => {
    try {
      const { data } = await axios.get('/api/profile/home/streets/', {
        params: { term: value },
      });

      if (data.isSucceeded) {
        this.setState({ streets: data.view });
      }
    } catch (error) {
      this.setState({ streets: [] });
    }
  }

  getHouses = async (value) => {
    const { street } = this.state;

    try {
      const { data } = await axios.get('/api/profile/home/houses/', {
        params: {
          streetId: street.id,
          term: value,
        },
      });

      if (data.isSucceeded) {
        this.setState({ houses: data.view });
      }
    } catch (error) {
      this.setState({ houses: [] });
    }
  }

  sendRequest = async (event) => {
    event.preventDefault();

    const {
      region,
      street,
      house,
      flat,
      phone,
    } = this.state;

    try {
      await axios.post('/api/home/account/createrelocationrequest/', {
        fullAddress: `${region}, ${street.label}, ${house.label}, кв ${flat}`,
        houseId: house.id,
        flat,
        phone,
      });

      this.setState({ isSuccess: true });
    } catch (error) {
      this.setState({ isError: true });
    }
  }

  render() {
    const { onClose } = this.props;
    const {
      region,
      street,
      house,
      flat,
      phone,
      streets,
      houses,
      isSuccess,
      isError,
    } = this.state;

    return (
      <Popup
        onClose={onClose}
        opened
      >
        {isSuccess && (
          <>
            <Heading className={cx('heading')} level={1}>
              Заявка на переезд отправлена
            </Heading>

            <div className={cx('buttonRow')}>
              <Button
                className="big"
                onClick={onClose}
              >
                Продолжить работу
              </Button>
            </div>
          </>
        )}

        {isError && (
          <>
            <Heading className={cx('heading')} level={1}>
              Что-то пошло не так
            </Heading>

            <div className={cx('buttonRow')}>
              <Button
                className="big"
                onClick={onClose}
              >
                Продолжить работу
              </Button>
            </div>
          </>
        )}

        {!isSuccess && !isError && (
          <>
            <Heading className={cx('heading')} level={1}>
              <I18n path="internet.newAddressForm.title" />
            </Heading>
            <div className={cx('description')}>
              <I18n path="internet.newAddressForm.description" />
            </div>

            <form
              className={cx('form')}
              onSubmit={this.sendRequest}
            >
              <Heading className={cx('formHeading')} level={3}>
                <I18n path="internet.newAddressForm.formTitle" />
              </Heading>

              <div className={cx('formRow')}>
                <div className={cx('formLabel')}>
                  <label htmlFor="region">
                    Населенный пункт
                  </label>
                </div>
                <div className={cx('formInput')}>
                  <TextInput
                    id="region"
                    name="region"
                    value={region}
                    disabled
                  />
                </div>
              </div>

              <div className={cx('formRow')}>
                <div className={cx('formLabel')}>
                  <label htmlFor="street">
                    Улица
                  </label>
                </div>
                <div className={cx('formInput')}>
                  <AutocompleteInput
                    id="street"
                    placeholder="Введи название улицы"
                    items={streets}
                    itemCaptionExtractor={(value) => value.label}
                    onFetchRequested={this.getStreets}
                    filter={(value, items) => items}
                    PendingComponent={() => (
                      <Preloader className={cx('inputPreloader')} size="36" />
                    )}
                    onChange={(value) => this.setState({ street: value, house: null })}
                    onClearRequested={() => this.setState({ street: null, house: null })}
                    showPending
                  />
                </div>
              </div>

              <div className={cx('formRow')}>
                <div className={cx('formLabel')}>
                  <label htmlFor="house">
                    Дом, корпус
                  </label>
                </div>
                <div className={cx('formInput')}>
                  <AutocompleteInput
                    id="house"
                    placeholder="Введи номер дома"
                    items={houses}
                    itemCaptionExtractor={(value) => value.label}
                    onFetchRequested={this.getHouses}
                    filter={(value, items) => items}
                    PendingComponent={() => (
                      <Preloader className={cx('inputPreloader')} size="36" />
                    )}
                    onChange={(value) => this.setState({ house: value })}
                    onClearRequested={() => this.setState({ house: null })}
                    showPending
                    disabled={!street}
                  />
                </div>
              </div>

              <div className={cx('formRow')}>
                <div className={cx('formLabel')}>
                  <label htmlFor="flat">
                    Квартира
                  </label>
                </div>
                <div className={cx('formInput')}>
                  <TextInput
                    id="flat"
                    placeholder="Укажи квартиру"
                    value={flat}
                    onChange={(value) => this.setState({ flat: value })}
                    disabled={!house || !house.isConnected}
                  />
                </div>
              </div>

              <div className={cx('formRow')}>
                <div className={cx('formLabel')}>
                  <label htmlFor="phone">
                    Номер телефона
                  </label>
                </div>
                <div className={cx('formInput')}>
                  <TextInput
                    id="phone"
                    placeholder="Оставь свой номер"
                    value={phone}
                    onChange={(value) => this.setState({ phone: value })}
                    disabled={!house || !house.isConnected}
                    mask="+7 ___ ___-__-__"
                  />
                </div>
              </div>

              {(!house || house.isConnected) ? (
                <div className={cx('buttonRow')}>
                  <Button
                    className="big"
                    disabled={(house && !house.isConnected) || !flat || !phone}
                  >
                    Оставить заявку на переезд
                  </Button>
                </div>
              ) : (
                <Status
                  className={['error', cx('status')]}
                  emoji="statusFail"
                >
                  К сожалению, ваш дом ещё не подключен
                </Status>
              )}
            </form>
          </>
        )}
      </Popup>
    );
  }
}

NewAddressPopup.propTypes = {
  onClose: PropTypes.func,
};
